import { render, staticRenderFns } from "./OperatorPermissionSelector.vue?vue&type=template&id=ab5dcb7a"
import script from "./OperatorPermissionSelector.vue?vue&type=script&lang=js"
export * from "./OperatorPermissionSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports